import { useEffect, useRef, useState } from "react";

export const useDimensions = () => {
  const ref = useRef(null);
  const [dimensions, setDimensions] = useState<any>({});
  useEffect(() => {
    setDimensions((ref.current as any).getBoundingClientRect());
  }, []);

  return [ref, dimensions];
};
